import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PanelMenu } from "primereact/panelmenu"
import useMainMenu from "../../hooks/useMainMenu"
import {
  buildPanelMenuModel,
  renderMaterialIconMenuItemTemplate,
} from "./components/helpers/menuBuilder"

import baseStyles from "../../styles/SidebarPanelMenuBase.module.css"

export default function EnterpriseMenuSidebar() {
  const navigate = useNavigate()
  const location = useLocation()

  // Pull only the Enterprise Management section from the shared menu config.
  const { menuItems: enterpriseSections, resolveMenuPath } = useMainMenu({
    includeLabels: ["Enterprise Management"],
  })

  // includeLabels returns at most one top-level match; render only its children
  // so this sidebar stays a simple submenu rather than an extra accordion level.
  const enterpriseItems = useMemo(
    () =>
      Array.isArray(enterpriseSections?.[0]?.items)
        ? enterpriseSections[0].items
        : [],
    [enterpriseSections],
  )

  const enterpriseMenuModel = useMemo(
    () =>
      // Keep route activation, icon rendering, and placeholder path resolution
      // aligned with other sidebars by using the shared menu builder.
      buildPanelMenuModel({
        items: enterpriseItems,
        pathname: location.pathname,
        navigate,
        itemTemplate: renderMaterialIconMenuItemTemplate,
        activeClassName: baseStyles.menuLinkActiveItem,
        resolvePath: resolveMenuPath,
        // Skip malformed entries from config snapshots.
        includeItem: ({ item }) => Boolean(item?.label),
      }),
    [enterpriseItems, location.pathname, navigate, resolveMenuPath],
  )

  if (!enterpriseMenuModel.length) {
    return null
  }

  return (
    <div className={baseStyles.menuRoot}>
      <PanelMenu
        key={`enterprise-menu-${location.pathname}`}
        model={enterpriseMenuModel}
        multiple={false}
      />
    </div>
  )
}
